import { ref } from 'vue'

export const posting = ref(false)
export const scroll_position = ref(null)
